import AxiosCustom from "../../../components/common/apiConfig";
import { put, takeLatest } from "@redux-saga/core/effects";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
    SelectOptionExam: "SelectOptionExam [Action]",
    SelectOptionExamLoading: "SelectOptionExamLoading [Action]",
    SelectOptionExamAsync: "SelectOptionExamAsync [Action]",
};
const inistiaState = {
    data: [],
    total:0,
    loading: false
};

export const reducerSelecOptionExamt = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.SelectOptionExam:
            return {
                ...state,
                data: payload.results,
                total: payload.total
                  ? payload.total > 10000
                    ? 10000
                    : payload.total
                  : 0
            };
        case actionTypes.SelectOptionExamLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.SelectOptionExamLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "questionnaire",
        method_type: "select_option_exam",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.SelectOptionExam, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.SelectOptionExamLoading, payload: false })

    }
}

export function* workerSelectOptionExamt() {
    yield takeLatest(actionTypes.SelectOptionExamAsync, handleWorker);
}
